import { gql } from 'apollo-angular';
import { Label } from '../../entities/label/label';

export const LABEL_DIALOG_QUERY = gql`
query GetLabel(
  $id: UUID
)
{
  label: getLabel(
    id: $id
  ) {
    id
    externalId
    name
    scope
    scopedName
    description
    color
  }
}
`;


export interface LabelDialogQueryResponse {
  label: Label;
}

export const IS_SCOPED_NAME_AVAILABLE_QUERY = gql`
query isScopedNameAvailable(
  $input: LabelInput
)
{
  isAvailable: isScopedNameAvailable(
    input: $input
  )
}
`;


export interface IsScopedNameAvailableQueryResponse {
  isAvailable: boolean;
}
